import moment from 'moment';

interface TickerSummaryProps {
	organizer?: string;
}

export const TickerSummary = ({ organizer }: TickerSummaryProps) => {
	const date = moment();

	return (
		<div className="flex w-24 shrink-0 flex-col divide-y divide-gray-300 border-x border-gray-300 bg-white sm:w-28">
			{organizer ? <div className="w-full text-center text-lg uppercase font-semibold py-4">{organizer}</div> : null}
			<div className="flex flex-1 flex-col items-center justify-center py-2 text-center">
				<span className="text-xs uppercase leading-5 tracking-wider text-gray-600">{date.format('MMM')}</span>
				<span className="text-xl font-bold uppercase tracking-wider text-black">{date.format('D')}</span>
			</div>
		</div>
	);
};
